import { ChangeEvent, FC } from 'react';
import styled from 'styled-components';

import Text from '@/components/Text';

const Wrap = styled.div`
  position: relative;
  margin: 0 0 12px;
`;

const Input = styled(Text)`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  height: 40px;
  padding: 0 40px;
  align-items: center;
  display: flex;
  outline: none;
  transition: 0.2s ease-out border-color;
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
  }
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.gray};
  }
`;

const Icon = styled.svg`
  position: absolute;
  left: 16px;
  top: 11px;
  color: ${({ theme }) => theme.colors.gray};
`;

interface Props {
  value: string;
  setValue: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const SearchBar: FC<Props> = ({
  value,
  setValue,
  placeholder = 'Search',
  disabled = false,
  className,
}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) =>
    setValue(e.target.value);

  return (
    <Wrap className={className}>
      <Icon
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.58101 14.5385C11.1357 14.5385 14.0173 11.6455 14.0173 8.07693C14.0173 4.50832 11.1357 1.61539 7.58101 1.61539C4.02634 1.61539 1.14471 4.50832 1.14471 8.07693C1.14471 11.6455 4.02634 14.5385 7.58101 14.5385Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1321 12.6462L15.856 16.3847"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Icon>
      <Input
        disabled={disabled}
        as="input"
        placeholder={placeholder}
        $type="smallBold"
        value={value}
        onChange={onChange}
        type="search"
      />
    </Wrap>
  );
};

export default SearchBar;
